import { render, staticRenderFns } from "./InsurersReports.component.html?vue&type=template&id=5b163e5b&"
import script from "./InsurersReports.component.ts?vue&type=script&lang=ts&"
export * from "./InsurersReports.component.ts?vue&type=script&lang=ts&"
import style0 from "./InsurersReports.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports